export const css = {
    root: '_3gtbl3jU',
    input: '_3X9kXPjD',
    inputWrapper: '_2r6o4AmN',
    radioBackground: '_2kqw2sYv',
    radioOuter: '_3-eVnThA',
    radioInner: '_25lcEp43',
    focused: 'EdvbCNSg',
    checked: 'KsoUxdzJ',
    disabled: '_2VbuG0M2',
    readonly: '_2ys5HPf7',
    invalid: 'dE1fEkLX',
    valid: '_1ySQHURr',
    ' _key': 'ascm-theme/ascm/dojo/radio'
};
export default css;
